import {Link, Outlet} from 'react-router-dom';
import {Fragment} from 'react';
import {toAbsoluteUrl} from '@/utils';
import useBodyClasses from '@/hooks/useBodyClasses';
import {AuthBrandedLayoutProvider} from './AuthBrandedLayoutProvider';
import {Footer} from "@/layouts/buddy";

const Layout = () => {
    // Applying body classes to manage the background color in dark mode
    useBodyClasses('dark:bg-coal-500');

    return (
        <Fragment>
            <style>
                {`
          .branded-bg {
            background-image: url('${toAbsoluteUrl('/media/images/xbg.png')}');
          }
          .dark .branded-bg {
            background-image: url('${toAbsoluteUrl('/media/images/xbg.png')}');
          }
        `}
            </style>

            <div className="grid lg:grid-cols-2 grow">
                <div className="flex justify-center items-center p-8 lg:p-10 order-2 lg:order-1">
                    <Outlet/>
                </div>

                <div
                    className="lg:rounded-xl lg:border lg:border-gray-200 lg:m-5 order-1 lg:order-2 bg-top xxl:bg-center xl:bg-cover bg-no-repeat branded-bg place-content-center">
                    <div className="flex justify-center p-8 lg:p-16 gap-4">
                        <div className="flex flex-col items-center gap-3">
                            <img
                                src={toAbsoluteUrl('/media/images/avatar-high.png')}
                                alt="avatar"
                                className="rounded-full"
                            />
                            <a
                                href="http://upflinx.com/impressum"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white no-underline hover:text-primary mt-2"
                            >
                                Imprint
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>

    );
};

// AuthBrandedLayout component that wraps the Layout component with AuthBrandedLayoutProvider
const AuthBrandedLayout = () => (
    <AuthBrandedLayoutProvider>
        <Layout/>
    </AuthBrandedLayoutProvider>
);

export {AuthBrandedLayout};
